import { render, staticRenderFns } from "./AdvancedProfilesTable.vue?vue&type=template&id=c66fb11c&"
import script from "./AdvancedProfilesTable.vue?vue&type=script&lang=js&"
export * from "./AdvancedProfilesTable.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedProfilesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports